<div [formGroup]="addCertificateToBoxForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Certificate</mat-label>
    <mat-select [(value)]="selectedCertificate" formControlName="certificate" name="certificate">
      <mat-option *ngIf="!loadingCertificates && certificates.length === 0">
        No certificates available.
      </mat-option>
      <mat-option *ngFor="let certificate of certificates" [value]="certificate">
        {{certificate?.cmId}} {{certificate?.endDate | date:"dd/MM/yyyy"}}
      </mat-option>
    </mat-select>
    <span *ngIf="loadingCertificates" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
    <mat-hint *ngIf="!loadingCertificates && certificates.length === 0" class="color-warn">
      No certificates available.
    </mat-hint>
  </mat-form-field>


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="box = _box; canceled.emit()" mat-button>Cancel</button>
    <button (click)="addCertificates()" [disabled]="addCertificateToBoxForm.invalid || saving" color="primary"
      mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>